export default class Routing {
    constructor( core ) {
        this.core = core
    }

    UrlToHome() {
        return `/`
    }
    
    UrlToNotFound() {
        return `/404`
    }

    ToHome() {
        this.core.historyPush( this.UrlToHome() )
    }

    ToNotFound() {
        this.core.historyPush( this.UrlToNotFound() )
    }
}